<style lang="scss">

</style>

<template>
  <section class="section__wrapper finances-statement">
    <header class="finances-statement__header z-20">
      <div class="finances-statement__filters">
        <div class="finances-statement__filters-item">
          <span class="finances-statement__filters-title">
            Período
          </span>

          <div class="finances-statement__filters-filter finances-statement__filters-calendar">
            <!-- Filter: startDate -->
            <div
              v-click-outside="() => uiControls.showStartCalendar = false"
              class="finances__widget-date"
            >
              <div
                :class="uiControls.showStartCalendar && 'active'"
                class="finances__widget-picker"
                @click="uiControls.showStartCalendar = !uiControls.showStartCalendar"
              >
                <span>
                  {{ $moment(filters.startDate).format('DD/MM/YYYY') }}
                </span>

                <dr-icon
                  :color="'#8E8E92'"
                  class="agenda-settings__date-picker--icon"
                  name="dashCalendar"
                />
              </div>

              <div class="finances__widget-calendar">
                <dr-calendar
                  v-show="uiControls.showStartCalendar"
                  :ref="'calendarStartDate'"
                  :key="'calendarStartDate'"
                  v-model="filters.startDate"
                  @change="uiControls.showStartCalendar = false"
                />
              </div>
            </div>

            <!-- Filter: endDate -->
            <div
              v-click-outside="() => uiControls.showEndCalendar = false"
              class="finances__widget-date"
            >
              <div
                :class="uiControls.showEndCalendar && 'active'"
                class="finances__widget-picker"
                @click="uiControls.showEndCalendar = !uiControls.showEndCalendar"
              >
                <span>
                  {{ $moment(filters.endDate).format('DD/MM/YYYY') }}
                </span>

                <dr-icon
                  :color="'#8E8E92'"
                  class="agenda-settings__date-picker--icon"
                  name="dashCalendar"
                />
              </div>

              <div class="finances__widget-calendar">
                <dr-calendar
                  v-show="uiControls.showEndCalendar"
                  :ref="'calendarEndDate'"
                  :key="'calendarEndDate'"
                  v-model="filters.endDate"
                  @change="uiControls.showEndCalendar = false"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-click-outside="() => uiControls.showCategories = false"
          class="finances-statement__filters-item"
        >
          <span class="finances-statement__filters-title">
            Categoria
          </span>

          <div class="finances-statement__filters-filter">
            <div class="dropdown-select">
              <div
                class="dropdown-select__value"
                @click="uiControls.showCategories = !uiControls.showCategories"
              >
                <span
                  :class="filters.categories.length > 0 && 'dropdown-select__selected--number'"
                  class="dropdown-select__selected"
                >
                  {{
                    filters.categories.length > 0
                      ? filters.categories.length
                      : 'Selecione'
                  }}
                </span>

                <i class="icon icon-arrow-down"></i>
              </div>

              <transition name="fade">
                <ul
                  v-if="uiControls.showCategories"
                  class="dropdown-select__list"
                >
                  <li
                    v-for="(category, index) in financialCategories"
                    :key="`financialCategory-${index}`"
                    :class="filters.categories.includes(category.id) && 'dropdown-select__list-item--checked'"
                    class="dropdown-select__list-item"
                    @click="checkOption(category.id, filters.categories)"
                  >
                    <span>{{ category.name }}</span>

                    <span v-show="filters.categories.includes(category.id)">
                      <i class="icon icon-check" />
                    </span>
                  </li>
                </ul>
              </transition>
            </div>
          </div>
        </div>

        <div
          v-click-outside="() => uiControls.showModalities = false"
          class="finances-statement__filters-item"
        >
          <span class="finances-statement__filters-title">
            Modalidade
          </span>

          <div class="finances-statement__filters-filter">
            <div class="dropdown-select">
              <div
                class="dropdown-select__value"
                @click="uiControls.showModalities = !uiControls.showModalities"
              >
                <span
                  :class="filters.modalities.length > 0 && 'dropdown-select__selected--number'"
                  class="dropdown-select__selected"
                >
                  {{
                    filters.modalities.length > 0
                      ? filters.modalities.length
                      : 'Selecione'
                  }}
                </span>

                <i class="icon icon-arrow-down" />
              </div>

              <transition name="fade">
                <ul
                  v-if="uiControls.showModalities"
                  class="dropdown-select__list"
                >
                  <li
                    v-for="(modality, index) in modalities"
                    :key="`modality-${index}`"
                    :class="filters.modalities.includes(modality.value) && 'dropdown-select__list-item--checked'"
                    class="dropdown-select__list-item"
                    @click="checkOption(modality.value, filters.modalities)"
                  >
                    <span>{{ modality.name }}</span>

                    <span v-show="filters.modalities.includes(modality.value)">
                      <i class="icon icon-check" />
                    </span>
                  </li>
                </ul>
              </transition>
            </div>
          </div>
        </div>

        <div
          v-click-outside="() => uiControls.showPaymentStatus = false"
          class="finances-statement__filters-item"
        >
          <span class="finances-statement__filters-title">
            Status do Pagamento
          </span>

          <div class="finances-statement__filters-filter">
            <div class="dropdown-select">
              <div
                class="dropdown-select__value"
                @click="uiControls.showPaymentStatus = !uiControls.showPaymentStatus"
              >
                <span
                  :class="filters.paymentStatus.length > 0 && 'dropdown-select__selected--number'"
                  class="dropdown-select__selected"
                >
                  {{
                    filters.paymentStatus.length > 0
                      ? filters.paymentStatus.length
                      : 'Selecione'
                  }}
                </span>

                <i class="icon icon-arrow-down"></i>
              </div>

              <transition name="fade">
                <ul
                  v-if="uiControls.showPaymentStatus"
                  class="dropdown-select__list"
                >
                  <li
                    v-for="(status, index) in paymentStatus"
                    :key="`paymentStatys-${index}`"
                    :class="filters.paymentStatus.includes(status.value) && 'dropdown-select__list-item--checked'"
                    class="dropdown-select__list-item"
                    @click="checkOption(status.value, filters.paymentStatus)"
                  >
                    <span>{{ status.name }}</span>

                    <span v-show="filters.paymentStatus.includes(status.value)">
                      <i class="icon icon-check" />
                    </span>
                  </li>
                </ul>
              </transition>
            </div>
          </div>
        </div>

        <div
          v-click-outside="() => uiControls.showStatementTypes = false"
          class="finances-statement__filters-item"
        >
          <span class="finances-statement__filters-title">
            Tipo do Lançamento
          </span>

          <div class="finances-statement__filters-filter">
            <div class="dropdown-select">
              <div
                class="dropdown-select__value"
                @click="uiControls.showStatementTypes = !uiControls.showStatementTypes"
              >
                <span
                  :class="filters.statementTypes.length > 0 && 'dropdown-select__selected--number'"
                  class="dropdown-select__selected"
                >
                  {{
                    filters.statementTypes.length > 0
                      ? filters.statementTypes.length
                      : 'Selecione'
                  }}
                </span>

                <i class="icon icon-arrow-down"></i>
              </div>

              <transition name="fade">
                <ul
                  v-if="uiControls.showStatementTypes"
                  class="dropdown-select__list"
                >
                  <li
                    v-for="(type, index) in statementTypes"
                    :key="`statementType-${index}`"
                    :class="filters.statementTypes.includes(type.value) && 'dropdown-select__list-item--checked'"
                    class="dropdown-select__list-item"
                    @click="checkOption(type.value, filters.statementTypes)"
                  >
                    <span>{{ type.name }}</span>

                    <span v-show="filters.statementTypes.includes(type.value)">
                      <i class="icon icon-check" />
                    </span>
                  </li>
                </ul>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <div class="finances-statement__new-statement">
        <button
          @click="newFinancialStatement()"
          class="btn btn-primary agenda-list__new finances-statement__button"
        >
          <i class="icon icon-plus" />
        </button>
      </div>
    </header>

    <transition name="fade">
      <article class="finances-statement__table">
        <header
          v-if="fn_IS_MOBILE()"
          class="report__table-header mobile"
          :class="$store.getters.getNewCertifierCredentialRequired ? 'withCredentials' : '' ">
          <div
            class="report__table-col"
          >
            {{ tableColumns[0] }}
          </div>
          <div
            v-for="col of getSelectedCols"
            :key="'col' + col"
            class="report__table-col !w-4/12 !px-0 bg-white">
            <select
              @change="selectCol($event, col)"
            >
              <option
              selected
              :disabled="true"
              class="text-right"
              >{{ colSelect[col] }}</option>
              <template v-for="(key, index) in getColSelect">
                <option
                  class="text-center"
                  :selected="key.value === col"
                  :value="key.value" :key="`${col}-option-${index}`">{{ key.name }}</option>
              </template>
            </select>
          </div>
        </header>
        <div v-else class="finances-statement__table-header">
          <div
            v-for="column of tableColumns"
            :key="`financeStatementTable_${column}`"
            class="finances-statement__table-header-col"
          >
            <span class="finances-statement__table-tit">{{ column }}</span>
          </div>
        </div>

        <div
          v-if="tableData.length > 0"
          class="finances-statement__table-body"
        >
          <!-- INICIO DO LOOP -->
          <template v-if="fn_IS_MOBILE()">
            <div
              v-for="(item, index) of getRows"
              :key="`statement-row-group_${index}`"
              class="finances-statement__table-row-group"
            >
              <div class="finances-statement__table-col--group">
                <div class="finances-statement__table-data">
                  <span>{{ $moment(item.day).format('MMM') }}</span>
                  <span>{{ $moment(item.day).format('DD') }}</span>
                </div>
              </div>
              <div class="finances-statement__table-col--group">
                <div
                  v-for="(statement, i) of item.statements"
                  :key="`statement-group-${index}-${i}`"
                  class="finances-statement__table-row"
                >
                  <div
                    v-for="(col, $index) of getSelectedCols"
                    :key="index + 'col' + $index"
                    :class="`finances-statement__table-col finances-statement__table-col--${col}`">
                    <template v-if="col === 'is_consolidated'">
                      <dr-switch
                        v-model="statement['is_consolidated']"
                        :key="`statement-consolidated-${index}-${i}`"
                        :id="statement.id"
                        class="m-auto !justify-center"
                        @change="updatePaymentStatus(statement.id, statement)"
                      />
                    </template>
                    <template v-else-if="col === 'value'">
                      <span :class="String(statement.type).toLowerCase()">
                        R$ {{ statement.value | TO_BRL }}
                      </span>
                    </template>
                    <template v-else-if="statement[col]">
                      {{ statement[col] || '(não informado)' }}
                    </template>
                  </div>

                  <div class="finances-statement__table-col--actions flex flex-col hidden w-0 pr-4">
                    <div v-show="
                      statement['financial_category'] &&
                      !appCategoryId.includes(statement['financial_category'].id)
                    ">
                      <button
                        class="finances-statement__actions-btn"
                        @click="openFinancialStatement(statement)"
                      >
                        <dr-icon
                          :color="'#8E8E92'"
                          class="finances-statement__actions-btn--edit"
                          name="edit"
                        />
                      </button>
                    </div>

                    <div v-show="
                      statement['financial_category'] &&
                      !appCategoryId.includes(statement['financial_category'].id)
                    ">
                      <button
                        class="finances-statement__actions-btn"
                        @click="removeFinancialStatement(statement)"
                      >
                        <dr-icon
                          :color="'#8E8E92'"
                          class="finances-statement__actions-btn--remove"
                          name="trash"
                        />
                      </button>
                    </div>

                      <div v-if="
                        'agenda' in statement &&
                        statement['agenda'] &&
                        statement['agenda'].id &&
                        /realizado/gi.test(statement['agenda'].status)
                      ">
                        <button
                          class="finances-statement__actions-btn"
                          @click="openReceipt(statement['agenda'].id)"
                        >
                          <dr-icon
                            :color="'#8E8E92'"
                            class="finances-statement__actions-btn--receipt"
                            name="receipt"
                          />
                        </button>
                      </div>
                  </div>
                  <div class="`finances-statement__table-col finances-statement__table-col--2`"></div>

                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div
              v-for="(item, index) of tableData"
              :key="`statement-row-group_${index}`"
              class="finances-statement__table-row-group"
            >
              <div class="finances-statement__table-col--group">
                <div class="finances-statement__table-data">
                  <span>{{ $moment(item.day).format('MMM') }}</span>
                  <span>{{ $moment(item.day).format('DD') }}</span>
                </div>
              </div>

              <div class="finances-statement__table-col--group">
                <div
                  v-for="(statement, i) of item.statements"
                  :key="`statement-group-${index}-${i}`"
                  class="finances-statement__table-row"
                >
                  <div v-if="statement.agenda" class="finances-statement__table-col finances-statement__table-col--name">
                    {{
                      (statement.agenda['user'])
                        ? statement.agenda['user'].name
                        : statement.agenda['special_patient'].name
                    }}
                  </div>
                  <div v-else class="finances-statement__table-col finances-statement__table-col--name">
                    Lançamento
                  </div>

                  <div class="finances-statement__table-col finances-statement__table-col--category">
                    {{ statement.description }}
                  </div>

                  <div class="finances-statement__table-col finances-statement__table-col--value">
                    <span :class="String(statement.type).toLowerCase()">
                      R$ {{ statement.value | TO_BRL }}
                    </span>
                  </div>

                  <div class="finances-statement__table-col finances-statement__table-col--mode">
                    {{ statement['payment_method'] || '(não informado)' }}
                  </div>

                  <div class="finances-statement__table-col finances-statement__table-col--payment">
                    <dr-switch
                      v-model="statement['is_consolidated']"
                      :key="`statement-consolidated-${index}-${i}`"
                      :id="statement.id"
                      @change="updatePaymentStatus(statement.id, statement)"
                    />
                  </div>

                  <div class="finances-statement__table-col finances-statement__table-col--actions">
                    <div v-show="
                      statement['financial_category'] &&
                      !appCategoryId.includes(statement['financial_category'].id)
                    ">
                      <button
                        class="finances-statement__actions-btn"
                        @click="openFinancialStatement(statement)"
                      >
                        <dr-icon
                          :color="'#8E8E92'"
                          class="finances-statement__actions-btn--edit"
                          name="edit"
                        />
                      </button>
                    </div>

                    <div v-show="
                      statement['financial_category'] &&
                      !appCategoryId.includes(statement['financial_category'].id)
                    ">
                      <button
                        class="finances-statement__actions-btn"
                        @click="removeFinancialStatement(statement)"
                      >
                        <dr-icon
                          :color="'#8E8E92'"
                          class="finances-statement__actions-btn--remove"
                          name="trash"
                        />
                      </button>
                    </div>

                      <div v-if="
                        'agenda' in statement &&
                        statement['agenda'] &&
                        statement['agenda'].id &&
                        /realizado/gi.test(statement['agenda'].status)
                      ">
                        <button
                          class="finances-statement__actions-btn"
                          @click="openReceipt(statement['agenda'].id)"
                        >
                          <dr-icon
                            :color="'#8E8E92'"
                            class="finances-statement__actions-btn--receipt"
                            name="receipt"
                          />
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div
          v-if="tableData.length === 0 && !uiControls.loading"
          class="finances-statement__table-loader"
        >
          <p class="finances-statement__table-no-results">
            Nenhum resultado encontrado.
          </p>
        </div>

        <transition name="fade">
          <div
            v-show="uiControls.loading"
            class="finances-statement__table-loader"
          >
            <dr-loader size="lg" />
          </div>
        </transition>
      </article>
    </transition>

    <footer
      v-show="isPagination && !uiControls.loading"
      class="finances-statement__footer"
    >
      <button
        class="btn btn-primary finances-statement__footer-see-more"
        @click="showMore()"
      >
        <span>Ver mais</span>
      </button>
    </footer>

    <dr-receipt
      v-if="uiControls.showReceipt"
      :id.sync="agendaId"
      @close="uiControls.showReceipt = false"
    />
  </section>
</template>

<script>
import DrReceipt from '@/components/layout/appointments/receipt'
import { DrCalendar } from 'cm2tech-vue-calendar'
import DrSwitch from '@/components/form/switch'
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

const modalities = [
  {
    id: 1,
    name: 'Cartão de débito',
    value: 'CARTÃO&nbsp;DE&nbsp;DÉBITO'
  },
  {
    id: 2,
    name: 'Cartão de crédito',
    value: 'CARTÃO&nbsp;DE&nbsp;CRÉDITO'
  },
  {
    id: 3,
    name: 'Dinheiro',
    value: 'DINHEIRO'
  },
  {
    id: 4,
    name: 'Cheque',
    value: 'CHEQUE'
  },
  {
    id: 5,
    name: 'Boleto',
    value: 'BOLETO'
  },
  {
    id: 6,
    name: 'Transferência Bancária',
    value: 'TRANSFERÊNCIA BANCÁRIA'
  }
]

const paymentStatus = [
  {
    id: 1,
    name: 'Confirmado',
    value: 1
  },
  {
    id: 2,
    name: 'Pendente',
    value: 0
  }
]

const statementTypes = [
  {
    id: 1,
    name: 'Receita',
    value: 'RECEITA'
  },
  {
    id: 2,
    name: 'Despesa',
    value: 'DESPESA'
  }
]

export default {
  name: 'financesList',

  components: {
    DrReceipt,
    DrCalendar,
    DrSwitch
  },

  props: {
    financialCategories: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data () {
    return {
      modalities,
      paymentStatus,
      statementTypes,
      agendaId: 0,
      uiControls: {
        loading: false,
        showStartCalendar: false,
        showEndCalendar: false,
        showCategories: false,
        showModalities: false,
        showPaymentStatus: false,
        showStatementTypes: false,
        showReceipt: false,
        selectedCols: ['name', 'description', 'value'],
        allCols: ['name', 'description', 'value', 'payment_method', 'is_consolidated']
      },
      filters: {
        startDate: null,
        endDate: null,
        categories: [],
        chosenCategories: [],
        modalities: [],
        chosenModalities: [],
        paymentStatus: [],
        chosenPaymentStatus: [],
        statementTypes: [],
        chosenStatementTypes: []
      },
      tableColumns: [
        'Data',
        'Nome',
        'Categoria',
        'Valor',
        'Modalidade',
        'Pagamento',
        'Ações'
      ],
      colSelect: {
        'name': 'Nome',
        'description': 'Categoria',
        'value': 'Valor',
        'payment_method': 'Modalidade',
        'is_consolidated': 'Pagamento'
      },
      tableData: [],
      pagination: {}
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    prefix () {
      const prefix = this.fn_GET_PARENT_ROUTE(this.$route)
      return `/${prefix}/doctor_office/${this.office.id}`
    },

    queryString () {
      const filterPaymentStatus = (this.filters.chosenPaymentStatus.length > 0)
        ? `&filterAndLike[fs.isConsolidated]=\
          ${this.filters.chosenPaymentStatus.join('&filterAndLike[fs.isConsolidated]=')}`
        : ''

      const filterCategories = (this.filters.chosenCategories.length > 0)
        ? `&filterIn[fs.financialCategory][]=\
          ${this.filters.chosenCategories.join('&filterIn[fs.financialCategory][]=')}`
        : ''

      const filterModalities = (this.filters.chosenModalities.length > 0)
        ? `&filterAndLike[fs.paymentMethod]=\
          ${this.filters.chosenModalities.join('&filterAndLike[fs.paymentMethod]=')}`
        : ''

      const filterStatementTypes = (this.filters.chosenStatementTypes.length > 0)
        ? `&filterAndLike[fs.type]=\
          ${this.filters.chosenStatementTypes.join('&filterAndLike[fs.type]=')}`
        : ''

      const startDate = this.$moment(this.filters.startDate).format('YYYY-MM-DD')
      const filterStartDate = `&filterAndGreaterThanOrEqual[fs.date]=${startDate}`

      const endDate = this.$moment(this.filters.endDate).format('YYYY-MM-DD')
      const filterEndDate = `&filterAndLessThanOrEqual[fs.date]=${endDate}`

      const filterCanceled = '&filterNot[fs.status]=CANCELADO'

      const filters = `?order[fs.date]=DESC\
        ${filterStartDate}\
        ${filterEndDate}\
        ${filterPaymentStatus}\
        ${filterCategories}\
        ${filterModalities}\
        ${filterStatementTypes}\
        ${filterCanceled}\
      `.replace(/\s/gm, '')

      return filters
    },

    apiUrl () {
      return `${this.prefix}/financial_statement${this.queryString}`
    },

    isPagination () {
      return (this.pagination.totalPages !== this.pagination.currentPage)
    },

    appCategoryId () {
      if (this.financialCategories.length > 0) {
        const regex = /conecta/gi
        return this.financialCategories.filter(category => regex.test(category.name)).map(({id}) => id)
      }

      return []
    },

    appointmentIds () {
      if (this.financialCategories.length > 0) {
        const regex = /consulta/gi
        return this.financialCategories
          .filter(category => regex.test(category.name))
          .map(item => item.id)
      }

      return []
    },

    getRows () {
      let arr = []
      for (let dayrow in this.tableData) {
        let obj = {
          day: this.tableData[dayrow].day,
          statements: []
        }
        for (let row of this.tableData[dayrow].statements) {
          let newRow = {}
          for (let col in row) {
            if (row.agenda || row.description) {
              newRow.name = row.agenda ? (row.agenda['user'] ? row.agenda['user'].name : row.agenda['special_patient'].name) : row.description
            }
            newRow[col] = row[col]
          }
          obj.statements.push(newRow)
        }
        arr.push(obj)
      }
      console.log(arr)
      return arr
    },

    getSelectedCols () {
      return this.uiControls.selectedCols
    },

    getUnselectedCols () {
      let arr = []
      for (let col of this.getSelectedCols) {
        for (let col2 of this.uiControls.allCols) {
          if (!arr.includes(col2) && !this.getSelectedCols.includes(col2)) {
            arr.push(col2)
          }
        }
      }
      return arr
    },

    getColSelect () {
      let arr = []
      for (let col of this.getUnselectedCols) {
        arr.push({
          name: this.colSelect[col],
          value: col
        })
      }
      return arr
    }
  },

  watch: {
    office: {
      deep: true,
      immediate: false,
      handler () {
        this.init()
      }
    },

    'filters.startDate': {
      immediate: false,
      deep: true,
      handler (newValue, oldValue) {
        const startDate = this.$moment(newValue)
        const endDate = this.$moment(this.filters.endDate)

        if (startDate.isAfter(endDate, 'day')) {
          this.filters.endDate = this.filters.startDate
          return
        }

        if (oldValue && !this.$moment(newValue).isSame(this.$moment(oldValue))) {
          EventBus.$emit('financial-summary-set-filter', { type: 'startDate', value: newValue })
        }
      }
    },

    'filters.endDate': {
      immediate: false,
      deep: true,
      handler (newValue, oldValue) {
        const endDate = this.$moment(newValue)
        const startDate = this.$moment(this.filters.startDate)

        if (endDate.isBefore(startDate, 'day')) {
          this.filters.startDate = this.filters.endDate
          return
        }

        if (oldValue && !this.$moment(newValue).isSame(this.$moment(oldValue))) {
          EventBus.$emit('financial-summary-set-filter', { type: 'endDate', value: newValue })
        }
      }
    },

    'uiControls.showCategories': {
      deep: false,
      immediate: false,
      handler (show) {
        if (!show) {
          this.filters.chosenCategories = [...this.filters.categories]
        }
      }
    },

    'uiControls.showModalities': {
      deep: false,
      immediate: false,
      handler (show) {
        if (!show) {
          this.filters.chosenModalities = [...this.filters.modalities]
        }
      }
    },

    'uiControls.showPaymentStatus': {
      deep: false,
      immediate: false,
      handler (show) {
        if (!show) {
          this.filters.chosenPaymentStatus = [...this.filters.paymentStatus]
        }
      }
    },

    'uiControls.showStatementTypes': {
      deep: false,
      immediate: false,
      handler (show) {
        if (!show) {
          this.filters.chosenStatementTypes = [...this.filters.statementTypes]
        }
      }
    },

    'uiControls.loading': {
      deep: false,
      immediate: true,
      handler () {
        if (!this.uiControls.loading && this.pagination.currentPage > 1) {
          this.$nextTick(() => {
            document.querySelector('footer.activity')
              .scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest'
              })
          })
        }
      }
    },

    queryString: {
      deep: false,
      immediate: true,
      handler (next, prev) {
        if (next !== prev) {
          this.init()
        }
      }
    }
  },

  created () {
    this.filters.startDate = this.$moment().subtract(1, 'M').toISOString()
    this.filters.endDate = this.$moment().toISOString()

    EventBus.$on('reload-finance', () => this.init())
  },

  destroyed () {
    this.tableData = []
    this.pagination = {}
    this.filters.startDate = null
    this.filters.endDate = null
    this.filters.categories = []
    this.filters.modalities = []
    this.filters.paymentStatus = []
  },

  methods: {
    init () {
      this.tableData = []
      this.pagination = {}
      this.fetchData()
    },

    fetchData (page = 1) {
      const url = `${this.apiUrl}&page=${page}`

      this.uiControls.loading = true
      this.fn_SHOW_PROGRESS()

      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          const { data, pagination } = res.data

          this.tableData = this.tableData.concat(this.groupData(data))
          this.pagination = { ...pagination }
        })
        .catch(err => console.log('err', err))
        .finally(() => {
          this.uiControls.loading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    showMore () {
      if (this.pagination.currentPage < this.pagination.totalPages) {
        this.fetchData(this.pagination.currentPage + 1)
      }
    },

    groupData (data) {
      const groupedData = []
      const dates = [...new Set(data.map(item => this.$moment(item.date).format('YYYY-MM-DD')))]
      dates.forEach(day => groupedData.push({ day, statements: [] }))

      groupedData.forEach((date) => {
        const filtered = data.filter((item) => {
          const when = this.$moment(item.date)
          if (when.isSame(this.$moment(date.day), 'd')) {
            return item
          }
        })

        date.statements = [...filtered]
      })

      return groupedData
    },

    newFinancialStatement () {
      EventBus.$emit('new-financial-statement', { ...this.doctorOffice })
    },

    openFinancialStatement (statement) {
      EventBus.$emit('new-financial-statement', { office: this.office, statement: statement })
    },

    updatePaymentStatus (id, statement) {
      const suffix = statement['is_consolidated'] ? 'consolidate' : 'deconsolidate'
      const url = `${this.prefix}/financial_statement/${id}/${suffix}`
      const payload = {
        consolidate: {
          paymentDate: this.$moment(statement.date).format('YYYY-MM-DD'),
          paidValue: statement.value
        }
      }

      this.fn_SHOW_PROGRESS()
      this.$http
        .put(url, payload, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Status do pagamento alterado com sucesso.',
            size: 'md',
            active: true
          })
        })
        .catch(err => this.handleError(err))
        .finally(() => this.fn_HIDE_PROGRESS())
    },

    callbackCalendar (date) {
      // filters: startDate
      if (this.uiControls.showStartCalendar) {
        const then = this.$moment(date)

        if (!this.$moment(this.filters.startDate).isSame(then)) {
          this.filters.startDate = { ...then }
        }

        this.uiControls.showStartCalendar = false
      }

      // filters: endDate
      if (this.uiControls.showEndCalendar) {
        const then = this.$moment(date)

        if (this.$moment(this.filters.startDate).isSameOrBefore(then, 'day')) {
          this.filters.endDate = { ...then }
        } else {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Por favor, escolha uma data maior que a data de início.',
            size: 'md',
            active: true
          })
        }

        this.uiControls.showEndCalendar = false
      }
    },

    checkOption (item, list) {
      if (list.includes(item)) {
        list.splice(list.indexOf(item), 1)
      } else {
        list.push(item)
      }
    },

    findErrorMessage (object) {
      let errorMessage = null

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => recursiveSearch(element))
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    },

    handleError (err) {
      const msg = (typeof err !== 'object')
        ? err
        : ('errors' in err)
          ? this.findErrorMessage(err.errors)
          : 'Ocorreu um erro.'

      this.$store.dispatch('setModalAlert', {
        title: 'Erro',
        body: Array.isArray(msg) ? msg[0] : msg,
        size: 'md',
        active: true
      })
    },

    removeFinancialStatement (statement) {
      let msg = `Tem certeza que deseja remover esse lançamento?`

      if (statement.agenda && statement.agenda.special_patient) {
        msg = `Ao remover uma entrada financeira relacionada a uma consulta,
        essa mesma consulta também será cancelada e será removida de sua agenda.
        Você ainda poderá visualiza-la no seu histórico de consultas.`
      }

      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: msg,
        confirmText: 'Confimar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            this.fn_SHOW_PROGRESS()
            const url = `${this.prefix}/financial_statement/${statement.id}`
            this.$http
              .delete(url, this.$store.getters.getAuthHeader)
              .then(() => this.init())
              .catch(err => this.fn_HANDLE_ERROR(err))
              .finally(() => this.fn_HIDE_PROGRESS())
          }
          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    },

    openReceipt (id) {
      this.agendaId = id
      this.uiControls.showReceipt = true
    },

    selectCol (ev, remove) {
      const selected = ev.target.value
      let newArr = []
      this.$set(this.uiControls.selectedCols, this.uiControls.selectedCols.indexOf(remove), selected)
      /* for (let col of this.uiControls.allCols) { // tem que usar este para pegar o índice correto
        if (selected === col || (this.uiControls.selectedCols.includes(col) && col !== remove)) {
          newArr.push(col)
        }
      }
      this.uiControls.selectedCols = newArr */
      // this.uiControls.selectedCols.splice(remove, 1)
      // this.uiControls.selectedCols.push(selected)
    }
  }
}
</script>
